import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface IFollowUpMethod extends IMetadata {
  followUpMethodId: number;
  followUpMethodDescription: string;
}

export const getFollowUpMethods = () =>
  getApiCached<IFollowUpMethod[]>('lookup/followupmethods');
